"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Results() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="9619" id="results-cta" className="relative overflow-hidden bg-background text-foreground">
      <div className="mx-auto max-w-7xl px-6 md:px-8 py-24 md:py-44">
        <div ref={ref} className="max-w-4xl mx-auto text-center">
          {}
          <div className={`font-default uppercase font-medium transition-all duration-[420ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          letterSpacing: "0.12em",
          fontSize: "clamp(0.75rem, 0.85vw, 0.875rem)",
          lineHeight: "1.0"
        }}>
            LIMITED ENROLLMENT OPENING SOON
          </div>

          {}
          <h2 className={`font-default mt-8 md:mt-10 transition-all duration-[420ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontWeight: 700,
          fontSize: "clamp(3rem, 8vw, 7rem)",
          letterSpacing: "-0.04em",
          lineHeight: "0.92",
          transitionDelay: "80ms"
        }}>
            <span className="block">ACHIEVE MORE.</span>
            <span className="block text-primary/20">
              SCALE FASTER.
            </span>
          </h2>

          {}
          <p className={`font-default mt-10 md:mt-12 mx-auto max-w-2xl transition-all duration-[420ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontWeight: 400,
          fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
          lineHeight: "1.55",
          letterSpacing: "-0.005em",
          transitionDelay: "160ms"
        }}>
            Only 48 spots available for our upcoming cohort. Secure your place to transform your business strategy today.
          </p>

          {}
          <div className={`mt-12 md:mt-14 flex justify-center transition-all duration-[420ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "240ms"
        }}>
            <Button className="rounded-lg font-default uppercase transition-all duration-[140ms] bg-secondary text-secondary-foreground shadow-md hover:opacity-90" style={{
            padding: "1.75rem 3.5rem",
            fontWeight: 700,
            letterSpacing: "0.04em",
            fontSize: "clamp(1rem, 1.4vw, 1.25rem)",
            height: "auto",
            transitionTimingFunction: "cubic-bezier(.4,0,.2,1)"
          }}>
              RESERVE YOUR PLACE
            </Button>
          </div>

          {}
          <p className={`font-default mt-8 md:mt-10 mx-auto max-w-2xl transition-all duration-[420ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontWeight: 400,
          fontSize: "clamp(0.9375rem, 1vw, 1rem)",
          lineHeight: "1.6",
          transitionDelay: "320ms"
        }}>
            Early bird pricing available · Full refund policy · Join the waitlist for priority access
          </p>
        </div>
      </div>
    </section>;
}